const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/estimates`,
    downloadFile: `${API_URL}/order/download-file`
};

export default apiUrls;
